module.exports = __webpack_public_path__ + "static/img/msg3.d37f1743.svg";